module.exports = __webpack_public_path__ + "static/media/68040.42ca34f9.jpg";